import { z } from 'zod'
import { dayTradePnlBreakdownSchema } from './day-trade-stats.schema'

// the snapshot-relevant slice shown in the resync before/after preview. mirrors the engine
// fields a user needs to judge a resync: held lots, average entry, the buy/sell anchors, the
// same-day realized P&L, the cumulative all-time realized P&L, and the committed cash.
export const dayTradeResyncSnapshotSchema = z.object({
  lotsHeld: z.number().int(),
  avgEntry: z.number(),
  lastBuyPrice: z.number().nullable(),
  lastSellPrice: z.number().nullable(),
  realizedToday: z.number(),
  // cumulative realized net P&L over the session's life (net of commission, pre-tax). only
  // changes between before/after when the stats recompute is requested.
  realizedAllTime: z.number(),
  cashCommitted: z.number(),
})

// request body for a resync (preview or apply): optionally also recompute the all-time realized
// accumulators from the full order ledger, not just rewrite the position from broker reality.
export const dayTradeResyncRequestSchema = z.object({
  recomputeStats: z.boolean().default(false),
})
export type DayTradeResyncRequestDto = z.infer<typeof dayTradeResyncRequestSchema>

// the result of a resync preview (dry-run) or apply: the engine state before vs. after, plus
// the raw broker position the "after" was derived from. when recomputeStats was requested,
// `statsAfter` carries the gross/commission/tax/net all-time breakdown the recompute produced.
export const dayTradeResyncResultSchema = z.object({
  before: dayTradeResyncSnapshotSchema,
  after: dayTradeResyncSnapshotSchema,
  brokerQuantity: z.number(),
  brokerAvgPrice: z.number(),
  recomputeStats: z.boolean(),
  statsAfter: dayTradePnlBreakdownSchema.nullable(),
})

export type DayTradeResyncSnapshotDto = z.infer<typeof dayTradeResyncSnapshotSchema>
export type DayTradeResyncResultDto = z.infer<typeof dayTradeResyncResultSchema>
